import sexOne from "./sex-one"
import sexTwo from "./sex-two"
import sexThree from "./sex-three"

const steps = [...sexOne, ...sexTwo, ...sexThree]

export default steps